import { isAfter } from 'date-fns'

const state = () => ({
  alreadyReadAdminInfoIds: [],
  notDisplayAdminInfos: []
})

const getters = {
  notDisplayAdminInfoIds(state) {
    return state.notDisplayAdminInfos.map(info => info.id)
  }
}

const mutations = {
  setAlreadyReadAdminInfoIds(state, alreadyReadAdminInfoIds) {
    state.alreadyReadAdminInfoIds = alreadyReadAdminInfoIds
  },
  setNotDisplayAdminInfos(state, notDisplayAdminInfos) {
    state.notDisplayAdminInfos = notDisplayAdminInfos
  },
}

const actions = {
  refreshNotDisplayAdminInfos({ state, commit }) {
    const now = new Date()
    // 掲載終了時刻が現在時刻を超えているお知らせを削除
    const notExpiredAdminInfos = state.notDisplayAdminInfos.filter(info => {
      const end = new Date(info.endDatetime)
      return isAfter(end, now)
    })
    commit('setNotDisplayAdminInfos', notExpiredAdminInfos)
  },

  // 掲載期間が変更されたときにlocalStorageデータをアップデートする必要がある
  updateNotDisplayAdminInfos({ getters, commit }, adminInfos) {
    const newNotDisplayAdminInfos = adminInfos.filter(info => {
      return getters.notDisplayAdminInfoIds.includes(info.id)
    })
    const infos = [
      ...newNotDisplayAdminInfos.map(info => ({
        id: info.id,
        endDatetime: info.endDatetime
      }))
    ]
    commit('setNotDisplayAdminInfos', infos)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}